import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  selectOnClick = () => {
    let select = document.querySelector(".option-container");
    select.classList.toggle("active");
  };

  optionsOnClick = (e) => {
    let selectList = document.querySelector(".option-container");
    let default_val = document.getElementById("defaultValue");
    let selected = e.target;

    selectList.classList.remove("active");
    selected.classList.add("selected");

    default_val.innerText = e.target.innerText;
    window.open(e.target.htmlFor, "_blank");
  };

  selectTranslationOnClick = () => {
    let select = document.querySelectorAll(".option-container")[1];
    select.classList.toggle("active");
  }


  optionTranslationOnClick = (lang) => (e) => {
    let selectList = document.querySelectorAll(".option-container")[1];
    let default_val = document.querySelectorAll("#defaultValue")[1];
    let options = document.querySelectorAll(".option-container")[1].querySelectorAll(".option label");
    let selected = e.target;

    options.forEach(option => {
      option.classList.remove("selected");
    });

    const { i18n } = this.props;
    i18n.changeLanguage(lang);

    selectList.classList.remove("active");
    selected.classList.add("selected");

    default_val.innerText = e.target.innerText;
  }

  render() {
    const { t } = this.props;
    const SHOW_TRANSLATION = /^(true|1)$/i.test(
      process.env.REACT_APP_DISPLAY_TRANSLATION || ""
    );
    return (
      <FooterWrapper>
        <FooterContainer>
          <FooterTop>
            <Link to="/" className="logo">
              <img src="/images/ctors/frame/head/logo_naxa.svg" alt="NEXA" />
            </Link>
            <ul>
              <li>
                <button>
                  <a href="/files/aotomonbiz-privacy-policy.pdf" download>
                    {t("key5")}
                  </a>
                </button>
              </li>
              <li>
                <button>
                  <a href="/files/aotomonbiz-terms-of-use.pdf" download>
                    {t("key6")}
                  </a>
                </button>
              </li>
            </ul>
          </FooterTop>
          <FooterBottom>
            <LeftArea>
              <SnsLink>
                <a
                  href="https://www.instagram.com/nanoomenergy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/ctors/icon/instar-icon.png"
                    alt="instar-icon"
                  />
                </a>
                <a
                  href="https://www.facebook.com/people/NanoomEnergy/100057263815739/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/ctors/icon/facebook-icon.png"
                    alt="facebook-icon"
                  />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC__5A5K1viwScBONTMI14Uw?view_as=subscriber"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/ctors/icon/youtube-icon.png"
                    alt="youtube-icon"
                  />
                </a>
                <a
                  href="https://blog.naver.com/nanoomenergy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/ctors/icon/blog-icon.png" alt="blog-icon" />
                </a>
              </SnsLink>
              <CompanyInfo>
                <ul>
                  <li>Company</li>
                  <li>Nanoomenergy</li>
                </ul>
                <ul>
                  <li>Call</li>
                  <li>1577-5242</li>
                </ul>
                <ul>
                  <li>E-mail</li>
                  <li>help@nanoomenergy.com</li>
                </ul>
              </CompanyInfo>
            </LeftArea>
            <RightArea>
              <SelectContainer>
                <div className="select" onClick={this.selectOnClick}>
                  <p id="defaultValue">Our Businesses</p>
                </div>
                <div className="option-container">
                  <div className="option" onClick={this.optionsOnClick}>
                    <label htmlFor="https://aotomon.com/">Aotomon</label>
                  </div>
                  {/* <div className="option" onClick={this.optionsOnClick}>
                    <label htmlFor="https://biz.aotomon.com/">
                      Aotomon Biz
                    </label>
                  </div> */}
                  <div className="option" onClick={this.optionsOnClick}>
                    <label htmlFor="https://sunnylogic.co.kr">
                      Sunny Logic
                    </label>
                  </div>
                  <div className="option" onClick={this.optionsOnClick}>
                    <label htmlFor="https://www.nanoomenergy.com/">
                      Nannoom Energy
                    </label>
                  </div>
                </div>
              </SelectContainer>
              {
                SHOW_TRANSLATION && (
                  <SelectContainer>
                    <div className="select" onClick={this.selectTranslationOnClick}>
                      <p id="defaultValue">Language</p>
                    </div>
                    <div className="option-container">
                      <div className="option" onClick={this.optionTranslationOnClick("ko")}>
                        <label>KOR</label>
                      </div>
                      {/* <div className="option" onClick={this.optionsOnClick}>
                        <label htmlFor="https://biz.aotomon.com/">
                          Aotomon Biz
                        </label>
                      </div> */}
                      <div className="option" onClick={this.optionTranslationOnClick("en")}>
                        <label>
                          ENG
                        </label>
                      </div>
                      <div className="option" onClick={this.optionTranslationOnClick("vi")}>
                        <label>
                          VNM
                        </label>
                      </div>
                    </div>
                  </SelectContainer>
                )
              }
              <p className="copyright">
                Copyright © 2024 Nanoomenergy inc. all rights reserved
              </p>
            </RightArea>
          </FooterBottom>
        </FooterContainer>
      </FooterWrapper>
    );
  }
}

const FooterWrapper = styled.div`
  width: 100%;
  padding: 30px 0;
  background-color: var(--grey-900);
`;
const FooterContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 0 auto;
`;
const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 20px;
  border-bottom: 1px solid #ffffff75;
  .logo {
    display: inline-block;
    text-align: left;
    width: 111px;
    height: 20px;
    img {
      width: auto;
      height: 100%;
      object-fit: contain;
    }
  }
  a {
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }
  ul {
    justify-self: end;
    li {
      display: inline-block;
      &:first-child {
        margin-right: 24px;
      }
      button {
        color: #fff;
        font-size: 14px;
        border: none;
        background-color: transparent;
      }
    }
  }
`;
const FooterBottom = styled.div`
  padding-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
`;
const LeftArea = styled.div``;
const SnsLink = styled.div`
  margin: 5px 0 15px 0;
  a {
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    &:nth-child(1),
    &:nth-child(2) {
      width: 20px;
      height: 20px;
    }
    &:nth-child(3) {
      width: 20px;
      height: 14px;
    }
    &:nth-child(4) {
      width: 21px;
      height: 20px;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;
const CompanyInfo = styled.div`
  ul {
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
  }
  li {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    color: #ffffff;
    &:first-child::after {
      content: "";
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 10px;
      background: #ffffff;
      margin: 0 8px;
    }
  }
`;
const RightArea = styled.div`
  justify-self: end;
  text-align: right;
  .copyright {
    clear: both;
    font-size: 14px;
    color: #fff;
  }
`;

const SelectContainer = styled.div`
  float: right;
  position: relative;
  width: 177px;
  margin-bottom: 10px;
  margin-left: 10px;
  .select {
    position: relative;
    width: 100%;
    cursor: pointer;
    p {
      width: 100%;
      padding: 10px 0;
      background-color: transparent;
      border: 1px solid #fff;
      border-width: 0 0 1px 0;
      text-align: left;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
    }
  }
  .select::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 10px;
    height: 5px;
    background-image: url("/images/ctors/icon/select-arrow.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .option-container {
    display: none;
    position: absolute;
    top: -120px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 5px;

    .option label {
      font-weight: 500;
      text-align: center;
      display: block;
      font-size: 16px;
      color: #191919;
      padding: 10px 12px;
      cursor: pointer;
    }
    .option:hover label,
    .option label.selected {
      background-color: #efeffc;
    }
    .option:first-child:hover label,
    .option:first-child label.selected {
      border-radius: 5px 5px 0 0;
    }
    .option:last-child:hover label,
    .option:last-child label.selected {
      border-radius: 0 0 5px 5px;
    }
  }
  .option-container.active {
    display: block;
  }
`;

export default withTranslation()(Footer);
